import { render, staticRenderFns } from "./Spents.vue?vue&type=template&id=95060740&"
import script from "./Spents.vue?vue&type=script&lang=js&"
export * from "./Spents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports